import { render, staticRenderFns } from "./modalRemove.vue?vue&type=template&id=39ee38da&scoped=true&"
import script from "./modalRemove.vue?vue&type=script&lang=js&"
export * from "./modalRemove.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=39ee38da&scoped=true&lang=css&"
import style1 from "./modalRemove.vue?vue&type=style&index=1&id=39ee38da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ee38da",
  null
  
)

export default component.exports